import { TransactionDetailType } from 'constants/loanApplication';

export const constructionOrImprovementCostsVisibility = [
  TransactionDetailType.CONSTRUCTION_CONVERSATION_OR_TO_PERMANENT,
  TransactionDetailType.RENOVATION,
];

export const closingTypeVisibility = [
  TransactionDetailType.CONSTRUCTION_CONVERSATION_OR_TO_PERMANENT,
];
